import { loginTaskPath } from '@/lib/auth/login-session';

type SignInFinalizeCapable = {
  finalize: (params: {
    navigate: (params: {
      session?: { currentTask?: { key: string } | null } | null;
      decorateUrl: (url: string) => string;
    }) => void | Promise<void>;
  }) => Promise<{ error: unknown }>;
};

/**
 * Complete a Clerk sign-in and navigate to the post-auth destination.
 *
 * A session that still owes a task (e.g. a forced password reset) goes to that
 * task's screen under `/login/tasks/<key>`. Sending it to bare `/login` showed
 * the sign-in form again, and every retry failed with "You're already signed in."
 */
export async function finalizeClerkSignIn(
  signIn: SignInFinalizeCapable,
  destination: string,
  navigateApp: (path: string) => void,
): Promise<void> {
  await signIn.finalize({
    navigate: async ({ session, decorateUrl }) => {
      const target = session?.currentTask
        ? loginTaskPath(session.currentTask.key, destination)
        : destination;
      const url = decorateUrl(target);
      if (url.startsWith('http')) {
        window.location.href = url;
        return;
      }
      navigateApp(url);
    },
  });
}
